import { COMPLIANCE_REVIEWS_LOCAL_STATUS } from "@/constants";

export default {
  complianceReviewList: {
    status: COMPLIANCE_REVIEWS_LOCAL_STATUS.INITIAL,
    errot: null,
    data: []
  },
  complianceReviewItem: {
    status: COMPLIANCE_REVIEWS_LOCAL_STATUS.INITIAL,
    error: null,
    data: {}
  }
};
